import { ConfigTri } from '../models/ConfigTri.model';

export class cumulConfigTri {
	date: Date;
	config: ConfigTri[];
}